import React from 'react';
import { Box, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import { InsightsDashboardName } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardName/InsightsDashboardName';
import { InsightsDashboardSection } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardSection/InsightsDashboardSection';
import { InsightsFormWrapper } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsFormWrapper/InsightsFormWrapper';
import { InsightsFilters } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsFilters/InsightsFilters';
import { useBusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useBusinessInsightsContext';
import { InsightsDashboardLoader } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardLoader/InsightsDashboardLoader';
import { InsightsDashboardLastUpdatedStatus } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardLastUpdatedStatus/InsightsDashboardLastUpdatedStatus';
import { getInsightsErrorStateVariant } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/BusinessAdminInsightsErrorState/BusinessAdminInsightsErrorState.utils';
import { BusinessAdminInsightsErrorState } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/BusinessAdminInsightsErrorState/BusinessAdminInsightsErrorState';

export function BusinessAdminInsightsContent(): JSX.Element {
  const { enabled, isError, isLoading, isDashboardMetadataLoaded } =
    useBusinessInsightsContext();

  const errorVariant = getInsightsErrorStateVariant({
    enabled,
    isError,
    isLoading,
  });

  const showLoader = !isDashboardMetadataLoaded && !isError;

  if (errorVariant !== null) {
    return (
      <Stack y="md">
        <BusinessAdminInsightsErrorState variant={errorVariant} />
      </Stack>
    );
  }

  if (showLoader) {
    return (
      <Stack y="md">
        <InsightsDashboardLoader />
      </Stack>
    );
  }

  return (
    <Box>
      <Stack y="md">
        <Flex justifyContent="space-between">
          <Box flex={1}>
            <Stack y="xxx-sm">
              <InsightsDashboardName />
            </Stack>
            <InsightsDashboardLastUpdatedStatus />
          </Box>
          <Box flex={1}>
            <InsightsFormWrapper>
              <InsightsFilters />
            </InsightsFormWrapper>
          </Box>
        </Flex>
      </Stack>
      <InsightsDashboardSection />
    </Box>
  );
}
